import React, {lazy} from 'react';
import {createRoot} from 'react-dom/client';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialMeta, getInitialPageState} from "@helpers/HelperInitialPageState";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import {ContextCartProvider} from "@contexts/ContextCartProvider";
import {ContextTLDProvider} from "@contexts/ContextTLDProvider";
import {ContextOperatorTaskProvider} from '@contexts/ContextOperatorTaskProvider';
import {ContextNotificationProvider} from "@contexts/ContextNotificationProvider";
import styles from './PagePartners.scss';
import Header from '@components/base/Header/Header';
import Footer from '@components/base/Footer/Footer';
import PartnersHeaderData from '@components/base/Header/data/PartnersHeaderData';
import ContentA1 from "@components/blocks/ContentA1/ContentA1";
import PassiveIncome from "@components/blocks/ContentA1/data/PassiveIncome";
import SomeThingBiggerData from "@components/blocks/ContentA1/data/SomeThingBiggerData";
import MenuBottom from "@components/base/MenuBottom/MenuBottom";
import ContentD1 from "@components/blocks/ContentD1/ContentD1";
import PartnersVideoData from "@components/blocks/ContentD1/data/PartnersVideoData";
import RequestForm from "@components/forms/RequestForm/RequestForm";
import PartnersFormData from "@components/forms/RequestForm/data/PartnersFormData";
import FAQ from "@components/blocks/FAQ/FAQ";
import PartnersFAQData from "@components/blocks/FAQ/data/PartnersFAQData";
import ContentA5 from "@components/blocks/ContentA5/ContentA5";
import WhatMakeUsDifferentData from "@components/blocks/ContentA5/data/WhatMakeUsDifferentData";

const PagePartners = (props) => {
	useSHCore({props, name: 'PagePartners', isPage: true});

	return (
	  <>
		  <ContextCartProvider>
			  <ContextServicePriceProvider>
				  <ContextTLDProvider>
					  <ContextNotificationProvider color={'color-brand-orange-400'}>
						  <Header data={PartnersHeaderData}/>

						  <main>
							  {/*<ContentD1*/}
							  {/*data={PartnersVideoData}*/}
							  {/*color={'color-brand-orange-400'}*/}
							  {/*blockSize={'800'}*/}
							  {/*videoSize={'640'}*/}
							  {/*/>*/}
							  <ContentA5 data={WhatMakeUsDifferentData} columns={3} color={'color-brand-orange-400'}/>
							  <ContentA1 data={PassiveIncome} color={'color-brand-orange-400'}/>

							  <ContextOperatorTaskProvider>
								  <RequestForm
									data={PartnersFormData}
									color={'color-brand-orange-400'}
								  />
							  </ContextOperatorTaskProvider>

							  <ContentA1 data={SomeThingBiggerData} color={'color-brand-orange-400'}/>
							  <FAQ
								data={PartnersFAQData}
								color={'color-brand-orange-400'}
								size={'900'}
								opened={true}
							  />

							  <MenuBottom color={'color-brand-orange-400'}/>
						  </main>

						  <Footer color={'color-brand-orange-400'}/>
					  </ContextNotificationProvider>
				  </ContextTLDProvider>
			  </ContextServicePriceProvider>
		  </ContextCartProvider>
	  </>
	)
};

const container = document.getElementById(getInitialMeta('pageAppId'));
const root = createRoot(container);
root.render(<PagePartners data={getInitialPageState()}/>);
